import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderOutlineSection,
  BackendMutationCreateLongFormBuilderOutlineSectionArgs,
} from 'src/types/backend';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateLongFormBuilderOutlineSection(
    $projectId: ID!
    $draftId: ID!
    $headline: String!
    $order: Int!
    $afterSectionId: ID
    $instructions: String
    $assetType: String!
    $generationTool: GenerationToolEnum
    $name: String
  ) {
    createLongFormBuilderOutlineSection(
      projectId: $projectId
      draftId: $draftId
      headline: $headline
      order: $order
      afterSectionId: $afterSectionId
      instructions: $instructions
      assetType: $assetType
      generationTool: $generationTool
      name: $name
    ) {
      ...LongFormSection
    }
  }
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;

type Variables = Omit<BackendMutationCreateLongFormBuilderOutlineSectionArgs, 'headline' | 'order'>;
type Result = BackendLongFormBuilderOutlineSection;

export const createLongFormBuilderOutlineSection = async ({
  projectId,
  draftId,
  afterSectionId,
  instructions,
  assetType,
  generationTool,
  name,
}: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      projectId,
      draftId,
      headline: '', // for backward compatibility, "headline" is not used in "long form" sections anymore
      order: -1, // for backward compatibility, FE now uses BE list order
      afterSectionId,
      instructions,
      assetType,
      generationTool,
      name,
    },
  });
  return getSingleProp<Result>(result.data);
};
